export const MAX_FILE_NAME_LENGTH = 17;
